import { unwrapResult } from "@reduxjs/toolkit"
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  TimePicker,
} from "antd"
import _, { set } from "lodash"
import moment from "moment"
import React, { ReactElement, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../../app/store"
import {
  getSettingDetail,
  saveSettingLabel,
  selectSettings,
  selectTenant,
} from "../../../user/setting/settingSlice"
import {
  selectEdition,
  selectUserDepartmentId,
} from "../../../../app/applicationSlice"
import { getPrintTemplateSettingList } from "../../../print/printSlice"
import { Tenant } from "../../../../models/tenant"
import { EditableList } from "../../../../compnents/list/EditableList"
import styles from "../insuranceContorl.module.css"
import {
  getAmountListAsync,
  getSettingDetailAsync,
  saveUserLimitInfoAsync,
} from "./AmountSlice"
import {
  getDoctorsInDepartment,
  selectDoctors,
  setDoctors,
} from "../../../registration/register/registerSlice"
import { Checks } from "../../../../models/setting"

export const Amount = (props: {type?: number}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const { Option } = Select

  const [form] = Form.useForm()

  const tenant = useSelector(selectTenant)

  const settings = useSelector(selectSettings)

  const [printFlag, setPrintFlag] = useState<any>(false)

  const [data, setData] = useState<any>([])

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const [page, setPage] = useState<any>({ items: [], total: 0 })

  const [loading, setLoading] = useState(false)

  const [visible, setVisble] = useState(false)

  const doctors = useSelector(selectDoctors)

  const [settingData, setSettingData] = useState<any>()

  const isOpenYBTJ = settings[Checks.YBTJ]

  const departmentId = useSelector(selectUserDepartmentId)

  const [doctorList, setDoctorList] = useState<any>([])

  useEffect(() => {
    dispatch(getSettingDetailAsync())
      .then(unwrapResult)
      .then((res: any) => {
        setSettingData(res)
      })
    setPrintFlag(isOpenYBTJ || false)
  }, [])

  const getPage = () => {
    dispatch(getAmountListAsync({ limitType: 0 }))
      .then(unwrapResult)
      .then((v: any) => {
        setData(v)
      })
  }

  useEffect(() => {
    getPage()
    dispatch(getDoctorsInDepartment(""))
  }, [])

  useEffect(() => {
    if (doctors?.length && data?.length) {
      setPage({
        ...page,
        items: data?.map((v: any) => {
          return {
            ...v,
            realname: doctors?.find((m: any) => m?.id == v?.userId)?.realname,
          }
        })?.filter((n: any) => n.realname)
      })
    } else {
      if(!data?.length) {
        setPage({
          ...page,
          items: [],
        })
      } else {
        setPage({ ...page })
      }
    }
  }, [doctors, data])

  useEffect(() => {
    if (doctors?.length && page?.items?.length) {
      setDoctorList(
        doctors?.map((v: any) => {
          return {
            ...v,
            limitValue:
              page?.items?.find((m: any) => m?.userId == v?.id)?.limitValue ||
              "",
          }
        })?.filter(n => n?.stationCategory == 1)
      )
    } else {
      setDoctorList(doctors)
    }
  }, [doctors, page])

  return (
    <div
      style={{
        height: "calc(100%)",
        marginTop: "10px",
        display: "flex",
        flexDirection: "column",
        background: "#FFFFFF",
        borderRadius: "10px",
        overflowY: "auto",
        paddingTop: props.type  == 1 ? '0' : "24px",
      }}
    >
      <Form labelAlign="right" form={form} autoComplete="off">
        <>
          <Row>
            <Col style={{ marginLeft: "24px" }}>
              <span>医生 医保帖均限制 : </span>
              <Checkbox
                checked={printFlag}
                style={{ marginLeft: "4px" }}
                onChange={(v) => {
                  setPrintFlag(v?.target.checked)
                  dispatch(
                    saveSettingLabel({
                      tenant: settingData?.tenent,
                      functionList: settingData?.functionList
                        ?.map((m: any) => {
                          return {
                            type: m.type,
                            value: m.value,
                          }
                        })
                        .concat({
                          type: Checks.YBTJ,
                          value: v?.target.checked,
                        }),
                    })
                  )
                    .then(unwrapResult)
                    .then(() => {
                      //   notification.success({
                      //     message: "保存成功",
                      //     duration: 3,
                      //   })
                      dispatch(getSettingDetail())
                    })
                    .catch(() => {
                      notification.error({
                        message: "保存失败",
                        duration: 3,
                      })
                      dispatch(getSettingDetail())
                    })
                }}
              >
                开启
              </Checkbox>
              <span style={{ fontSize: "12px", color: "#FFA037" }}>
                （医生开方超过该帖均金额后将无法结算）
              </span>
            </Col>
          </Row>
          <Row style={{ paddingLeft: 155, marginTop: 10, marginBottom: 10 }}>
            <Button type="primary" onClick={() => setVisble(true)}>
              编辑
            </Button>
          </Row>
        </>
      </Form>
      <Row className={styles.custom_scrollbar}>
        <Col style={{ marginLeft: 155, width: "400px" }}>
          <EditableList
            style={{
              width: "100%",
            }}
            scroll={{ y: 400 }}
            rowKey={(v, i) => `${i}`}
            page={{
              current: 1,
              size: 10,
              total: page?.total,
              items: page?.items,
            }}
            pagination={false}
            columns={[
              {
                title: "序号",
                key: "no",
                align: "center",
                width: "4rem",
                render: (_1, _2, i) => `${i + 1}`,
              },
              {
                title: "医生",
                align: "center",
                dataIndex: "realname",
                width: "10rem",
                ellipsis: true,
              },
              {
                title: "医保最高帖均金额",
                align: "center",
                dataIndex: "limitValue",
                width: "10rem",
                ellipsis: true,
              },
            ]}
          />
        </Col>
      </Row>

      <Modal
        title={"医生医保帖均编辑"}
        visible={visible}
        okText="确认"
        cancelText="取消"
        width={600}
        confirmLoading={loading}
        maskClosable={false}
        onOk={() => {
          setLoading(true)
          dispatch(
            saveUserLimitInfoAsync(
              doctorList
                ?.filter((m: any) => m.limitValue)
                ?.map((v: any) => {
                  return {
                    userId: v?.id,
                    limitValue: v?.limitValue,
                    limitType: 0,
                  }
                })
            )
          )
            .then(unwrapResult)
            .then(() => {
              notification.success({
                message: "保存成功,需要重新登陆后生效",
                duration: 3,
              })
              setLoading(false)
              setVisble(false)
              getPage()
            })
        }}
        onCancel={() => {
          setVisble(false)
        }}
        className={styles.amount}
        destroyOnClose
      >
        <Row style={{ padding: "10px 0", color: "#FFA037" }}>说明：帖均为空开方时则不限制</Row>
        <EditableList
          style={{
            width: "100%",
          }}
          scroll={{ y: 400 }}
          rowKey={(v, i) => `${i}`}
          page={{
            current: 1,
            size: 10,
            total: page?.total,
            items: doctorList,
          }}
          pagination={false}
          columns={[
            {
              title: "序号",
              key: "no",
              align: "center",
              width: "4rem",
              render: (_1, _2, i) => `${i + 1}`,
            },
            {
              title: "科室",
              align: "center",
              dataIndex: "outpatientDepartmentName",
              width: "8rem",
              ellipsis: true,
            },
            {
              title: "医生",
              align: "center",
              dataIndex: "realname",
              width: "8rem",
              ellipsis: true,
            },
            {
              title: "医保最高帖均金额",
              align: "center",
              dataIndex: "limitValue",
              width: "10rem",
              ellipsis: true,
              editable: true,
              rules: [
                {
                  pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
                  message: "请输入正确的格式，最多保留小数点后5位",
                },
              ],
              onSave: (prev, next) => {
                const newData: any = {
                  ...prev,
                  limitValue: next.limitValue,
                }
                setDoctorList(
                  doctorList.map((v: any) => {
                    return v.id == newData.id ? newData : v
                  })
                )
              },
              render: function Element(_, t: any) {
                return t.limitValue ? (
                  t.limitValue
                ) : (
                  <Input placeholder="请输入" style={{ width: "100%" }} />
                )
              },
            },
          ]}
        />
      </Modal>
    </div>
  )
}
